import "./News.module.css";
import Header from "@/reusable_sections/Header";
import Awareness from "./sections/Awareness";
import RecentUpdates from "./sections/RecentUpdates";
import Missioncalltoaction from "./sections/Missioncalltoaction";
import Campaign from "./sections/Campaign";
import FeaturedArticleHero from "./sections/FeaturedArticleHero";
import Womensequalitynewsgrid from "./sections/Womensequalitynewsgrid";
import Campaigns from "./sections/Campaigns";
import Footer from "@/reusable_sections/Footer";
export default function NewsPage() {
  return <div>
      <Header />
      <Awareness />
      <Campaign />
      <FeaturedArticleHero />
      <Womensequalitynewsgrid />
      <RecentUpdates />
      <Missioncalltoaction />
      <Campaigns />
      <Footer />
    </div>;
}